export function isBase64(str: string | (string | null)[] | null): boolean {
  if (str && typeof str === 'string') {
    const base64Regex =
      /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
    return base64Regex.test(str)
  }

  return false
}
